import React from 'react';
import { Box, Text, Flex } from '@chakra-ui/react';

interface SelectButtonProps {
  value: string;
  isSelected: boolean;
  onChange: (value: string) => void;
  children: React.ReactNode;
}

export default function SelectButton({ 
  value, 
  isSelected, 
  onChange, 
  children,
}: SelectButtonProps) {
  return (
    <Flex
      onClick={() => onChange(value)}
      cursor="pointer"
      flexDirection="row-reverse"
      alignItems="center"
      justifyContent="space-between"
      bg="#fafafa"
      borderRadius="xl"
      p={2}
      px={4}
      minHeight="36px"
    >
      <Box
        w="20px"
        h="20px"
        borderRadius={"full"}
        border="2px solid"
        borderColor={isSelected ? "var(--color-orange)" : "var(--color-grey-light)"}
        bg={isSelected ? "var(--color-orange)" : "transparent"}
        position="relative"
        transition="all 0.2s"
        _hover={{
          borderColor: isSelected ? "var(--color-orange)" : "var(--color-grey)"
        }}
      >
        {isSelected && (
          <Box
            position="absolute"
            top="50%"
            left="50%"
            transform="translate(-50%, -50%)"
            w="8px"
            h="8px"
            borderRadius="full"
            bg="white"
          />
        )}
      </Box>
      <Text
        fontSize="var(--base-font-size-small)"
        ml={0}
      >
        {children}
      </Text>
    </Flex>
  );
}